import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty-eight',
  templateUrl: './home-thirty-eight.component.html',
  styleUrls: ['./home-thirty-eight.component.scss']
})
export class HomeThirtyEightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
